import React, { Component } from 'react';

import { connect } from 'react-redux';

import {
    fetchStationDetailsAction,
    stationSelectors,
} from 'wanderu-ducks-stations';

import DirectionsMap from '../../components/DirectionsMap/DirectionsMap';
import Events from '../../events/DirectionsEvents';

class DirectionsMapContainer extends Component {
    trackEvent = () => {
        const {
            nearby,
            departStationId,
            tripId,
            type,
        } = this.props;

        Events.externalDirectionsLinkClicked({
            tripId,
            stationId: departStationId,
            nearby,
            type,
        });
    };

    render() {
        const {
            arriveLoading,
            arriveStation,
            arriveSuccess,
            departLoading,
            departStation,
            departSuccess,
            ...otherProps
        } = this.props;

        return (
            <DirectionsMap
                arriveLoading={arriveLoading}
                arriveStation={arriveStation}
                arriveSuccess={arriveSuccess}
                departLoading={departLoading}
                departStation={departStation}
                departSuccess={departSuccess}
                trackEvent={this.trackEvent}
                {...otherProps}
            />
        );
    }
}

function mapStateToProps(appState, ownProps) {
    const {
        arriveStationId,
        departStationId,
    } = ownProps;
    const arriveLoading = fetchStationDetailsAction.selectWorking(appState, arriveStationId);
    const arriveSuccess = fetchStationDetailsAction.selectSuccess(appState, arriveStationId);
    const departLoading = fetchStationDetailsAction.selectWorking(appState, departStationId);
    const departSuccess = fetchStationDetailsAction.selectSuccess(appState, departStationId);

    return {
        arriveLoading,
        arriveSuccess,
        departLoading,
        departSuccess,
        arriveStation: stationSelectors.selectStationDetails(appState, arriveStationId),
        departStation: stationSelectors.selectStationDetails(appState, departStationId),
    };
}

const mapDispatchToProps = {
    fetchStationDetails: fetchStationDetailsAction.fetch,
};

export { DirectionsMap };
export default connect(mapStateToProps, mapDispatchToProps)(DirectionsMapContainer);
